import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import EmptyList from 'src/components/templates/EmptyList.template';
import AppAssets from 'src/constants/appAssets';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
const SubjectNotesEmptyList = ({ onAddNote }) => {
    const [{}] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    return (React.createElement(EmptyList, { message: translate('No notes added yet'), image: {
            type: 'image',
            source: {
                uri: AppAssets.notesEmptyList,
            },
        } }, onAddNote != null && (React.createElement(Button, { onPress: onAddNote, LeftIcon: props => React.createElement(FeatherIcon, { name: "plus", ...props }) }, translate('Add Note')))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default SubjectNotesEmptyList;
